import React, {ReactElement} from 'react';
import {Props} from './Props';
import DateTimeFormatted from '../../../../../../components/DateTimeFormatted';
import MessageAgeInMinutes from '../../../../../../components/MessageAgeInMinutes';

class DialogRoadWorkPlanned extends React.Component<Props> {
    render(): ReactElement {
        const {properties, showRecordIds} = this.props;

        return (
            <table>
                <tbody>
                    {showRecordIds && (
                        <tr>
                            <th>ID</th>
                            <td>{properties.id}</td>
                        </tr>
                    )}
                    <tr>
                        <th>Bron</th>
                        <td>{properties.source}</td>
                    </tr>
                    <tr>
                        <th>Soort</th>
                        <td>{properties.type}</td>
                    </tr>
                    <tr>
                        <th>Aangemaakt op</th>
                        <td>
                            <DateTimeFormatted dateTime={properties.createdAt} />
                            <br />
                            <MessageAgeInMinutes time={properties.createdAt} />
                        </td>
                    </tr>
                    <tr>
                        <th>Laatste aanpassing op</th>
                        <td>
                            <DateTimeFormatted dateTime={properties.lastModifiedAt} />
                            <br />
                            <MessageAgeInMinutes time={properties.lastModifiedAt} />
                        </td>
                    </tr>
                    <tr>
                        <th>Begin tijd</th>
                        <td>
                            <DateTimeFormatted dateTime={properties.startedAt} />
                            <br />
                            <MessageAgeInMinutes time={properties.startedAt} />
                        </td>
                    </tr>
                    <tr>
                        <th>Eind tijd</th>
                        <td>
                            <DateTimeFormatted dateTime={properties.endedAt} />
                            <br />
                            <MessageAgeInMinutes time={properties.endedAt} />
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

export default DialogRoadWorkPlanned;
